import { createFileRoute } from '@tanstack/react-router';
import { RequireRole } from '../components/RequireRole';
import { VendorCommissionsPage } from '../features/finance/VendorCommissionsPanel';

/**
 * Commissions vendeurs du réseau / de l'équipe. Le rôle ne suffit pas :
 * l'API applique en plus le drapeau et le réglage du RP (403 sinon).
 */
export const Route = createFileRoute('/commissions')({
  component: () => (
    <RequireRole
      allow={['responsable_partenaire', 'responsable_backoffice', 'manager', 'superviseur']}
    >
      <VendorCommissionsPage />
    </RequireRole>
  ),
});
